<template>
  <div class="dropdown">
    <div @click.stop="show"><slot name="btn"  /></div>
    <div v-show="visible" class="dropdown-content">
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dropdown",
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    show() {
      let self = this
      this.visible = true
      document.addEventListener("click", () => { self.hide() }, {once: true})
    },
    hide() {
      this.visible = false
    },
  },
}
</script>

<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
  z-index: 999;
}
.dropdown-content {
  display: block;
  position: absolute;

  right: 0; /* 右对齐 */
}
</style>